import { mergeStates } from '../../../iwProvider/StoreHelper';
import { MANUAL_PAYMENT } from './ManualPaymentModal.actions';

const initialState = {
    amount: 0,
    accountNumber: '',
    sortCode: '',
    iban: '',
    name: '',
    reference: ''
};

type TState = {
    amount: number;
    accountNumber: string;
    sortCode: string;
    iban: string;
    name: string;
    reference: string;
};

type TAction = {
    type: typeof MANUAL_PAYMENT;
    amount: number;
    accountNumber?: string;
    sortCode?: string;
    iban?: string;
    name: string;
    reference: string;
};

// eslint-disable-next-line import/no-default-export
export default function (
    state: TState = mergeStates(initialState),
    action: TAction
): TState {
    switch (action.type) {
        case MANUAL_PAYMENT:
            return mergeStates(state, {
                amount: action.amount,
                manualPaymentConfirmed: false,
                accountNumber: action.accountNumber,
                sortCode: action.sortCode,
                iban: action.iban,
                name: action.name,
                reference: action.reference
            });
        default:
            return state;
    }
}
